import { NOTIFICATION } from './actionTypes';
import ResponseError from '../../models/ResponseError';
import Notification from '../../models/Notification';

function notifications(notification: Notification) {
  return {
    type: NOTIFICATION,
    data: notification
  }
}

function receiveError(error: ResponseError) {
  return (dispatch: any) => {
    const notification = {
      type: 'Error',
      message: error.longDescription
    }
    dispatch(notifications(notification));
  };
}

function receiveSuccess(message: string) {
  return (dispatch: any) => {
    const notification = {
      type: 'Success',
      message: message
    }
    dispatch(notifications(notification));
  };
}

function resetNotification() {
  return (dispatch: any) => {
    const notification = {
      type: '',
      message: ''
    }
    dispatch(notifications(notification));
  };
}

export {
  receiveError,
  receiveSuccess,
  resetNotification
}